import { render, staticRenderFns } from "./AppMenuAction.vue?vue&type=template&id=52fad813"
import script from "./AppMenuAction.vue?vue&type=script&lang=js"
export * from "./AppMenuAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports